import React, { useState, useEffect } from 'react';
import { Card, Table, Button } from 'antd';
import { EditOutlined, PlusOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import axios from '../util/axiosConfig'
import '../styles/userlist.css'
import { usePagination } from '../context/PaginationProvider';

const RoleList: React.FC = () => {
    const { pagination, setTotal, setPage, setPageSize } = usePagination();
    const { page, pageSize, sort_by, sort_order } = pagination;
    const [roles, setRoles] = useState<any>([]);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [, setPaginationConfig] = useState({
        current: page,
        pageSize: pageSize,
        total: 0,
        showTotal: (total: number, range: [number, number]) => `Showing ${range[0]}-${range[1]} of ${total} entries`,
        showSizeChanger: true,
        pageSizeOptions: ["5", "10", "20", "50"],
        locale: { items_per_page: "" },
        onChange: (page: number, pageSize: number) => {
            setPage(page);
            setPageSize(pageSize);
            setPaginationConfig((prev: any) => ({
                ...prev,
                current: page,
                pageSize: pageSize,
            }));
        },
        onShowSizeChange: (current: number, size: number) => {
            setPage(current);
            setPageSize(size);
            setPaginationConfig((prev: any) => ({
                ...prev,
                current: current,
                pageSize: size,
            }));
        },
    });

    const fetchRoleList = async () => {
        setLoading(true);
        try {
            const response = await axios.post('/roles/pageable-roles', {}, {
                params: {
                    pageSize: pageSize,
                    pageNo: page - 1,
                    sortByField: sort_by,
                    sortDirection: 'desc',
                },
            });
            const content = response?.data?.data?.content || [];
            if (Array.isArray(content)) {
                setRoles(content);
                setTotal(response.data?.data?.totalElements || 0);
                setPaginationConfig((prev) => ({
                    ...prev,
                    total: response.data?.data?.totalElements || 0,
                }));
            } else {
                console.error('Unexpected response format:', response.data);
            }
        } catch (error) {
            console.error('Failed to fetch panel data', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchRoleList();
        // eslint-disable-next-line
    }, [page, pageSize, sort_by, sort_order]);

    const handleEdit = (id: any, record: any) => {
        navigate(`/role-list/edit/${id}`);
    };

    const handleAdd = () => {
        navigate(`/role-list/add`);
    };

    const columns: any = [
        {
            title: 'Role Name',
            dataIndex: 'name',
            key: 'name',
            width: '45%'
        },
        {
            title: 'Status',
            key: 'active',
            dataIndex: 'active',
            render: (id: number, item: any) => {
                if (item.active === true) {
                    return (
                        <span style={{ 'color': '#00BC40' }}>
                            Active
                        </span>
                    )
                } else if (item.active === false) {
                    return (
                        <span style={{ 'color': '#CF1919' }}>
                            Inactive
                        </span>
                    )
                } else {
                    return '-';
                }
            },
            ellipsis: false,
            width: '45%'
        },
        {
            title: 'Action',
            key: 'action',
            width: '20%',
            render: (text: any, record: any) => (
                <>
                    <EditOutlined style={{ cursor: 'pointer' }} onClick={() => handleEdit(record?.id, record)} />
                </>
            ),
        },
    ];

    return (
        <>
            <Card
                title="Masters - User Roles List"
                bordered={false}
                extra={
                    <Button
                        type="primary"
                        icon={<PlusOutlined />}
                        onClick={handleAdd}
                    >
                        Add User Role
                    </Button>
                }
            >
                <Table
                    loading={loading}
                    className='roleTable'
                    dataSource={roles}
                    columns={columns}
                    bordered={false}
                    size='small'
                />
            </Card>
        </>
    );
};

export default RoleList;
